<template>
  <!-- This component handles global notifications -->
  <!-- Vuetify's v-snackbar will be used through the app store -->
  <div></div>
</template>

<script setup lang="ts">
// This component is a placeholder for global notifications
// The actual notifications are handled by the app store and can be
// triggered using appStore.showNotification()
</script>
